export default __webpack_public_path__ + "static/media/lesnik_winter_freezing_b.ce9824aa.svg";